module.exports = {
  fr: {
    path: 'fr',
    locale: 'Français',
    default: true,
  },
  en: {
    path: 'en',
    locale: 'English',
  },
}
